import { useAppSelector } from 'src/app/store/hooks';
import {
  ModeEnum,
  RunBambiRunWrite,
  useRunBambiRunCreateMutation,
} from 'src/common/external/bambi-api/bambiApi';

import { makeDispatchTimeRange } from '../../common/makeDispatchTimeRange';

export function useRunBambiRun() {
  const selectedDate = useAppSelector((state) => state.dispatcher.selectedDate);
  const [startImpl] = useRunBambiRunCreateMutation();
  const dispatchTimeRange = makeDispatchTimeRange(selectedDate);

  return ({
    tripIds,
    assignments,
    shouldMultiload,
    mode,
  }: {
    tripIds: string[];
    assignments: string[];
    shouldMultiload: boolean;
    mode: ModeEnum;
  }) => {
    const runBambiRun: RunBambiRunWrite = {
      range_start: dispatchTimeRange.start,
      range_end: dispatchTimeRange.end,
      trips: tripIds,
      assignments,
      should_multiload: shouldMultiload,
      mode,
    };

    return startImpl({
      runBambiRun,
    });
  };
}
